import type {Commit} from 'vuex';
import type {CompanyInterface} from '@/types/company';
import type {Connection} from '@/types';
import type {PlatformConnectionsMap} from '@/types/platform';

const dedicatedPlatformModules = [
    {platform: 'getaround', module: 'getaround', mutation: 'SET_GETAROUND_CONNECTIONS'},
    {platform: 'turo', module: 'turo', mutation: 'SET_TURO_CONNECTIONS'},
    {platform: 'tesla', module: 'tesla', mutation: 'SET_TESLA_CONNECTIONS'},
    {platform: 'bouncie', module: 'bouncie', mutation: 'SET_BOUNCIE_CONNECTIONS'},
] as const;

const credentialPlatformModules = [
    {platform: 'outdoorsy', module: 'outdoorsy', mutation: 'SET_OUTDOORSY_CONNECTIONS'},
    {platform: 'hq-rentals', module: 'hqRentals', mutation: 'SET_HQRENTALS_CONNECTIONS'},
    {platform: 'twisted_road', module: 'twistedRoad', mutation: 'SET_TWISTED_ROAD_CONNECTIONS'},
] as const;

function resolveCredentialConnections(company: CompanyInterface): PlatformConnectionsMap {
    return company.platform_connections ?? {};
}

export function hydratePlatformConnections(commit: Commit, company: CompanyInterface): void {
    dedicatedPlatformModules.forEach(({platform, module, mutation}) => {
        const payload = company.connections?.[platform as keyof NonNullable<CompanyInterface['connections']>] ?? [];

        commit(`${module}/${mutation}`, payload, {root: true});
    });

    const credentialConnections = resolveCredentialConnections(company);

    credentialPlatformModules.forEach(({platform, module, mutation}) => {
        const connectionKey = platform as keyof PlatformConnectionsMap;
        const connectionsKey = platform as keyof NonNullable<CompanyInterface['connections']>;
        const payload = (
            credentialConnections[connectionKey]
            ?? company.connections?.[connectionsKey]
            ?? []
        ) as Connection[];

        commit(`${module}/${mutation}`, payload, {root: true});
    });
}
